import { Customer } from "./customers.model";
import { Profession } from "./professions.model";

export class Contact {
    id: number;
    name: string;
    phone1: string;
    phone2: string;
    email: string;
    customer: Customer;
    profession: Profession;

    constructor() {
        this.customer = new Customer();
        this.profession = new Profession();
    }
}

export class ContactForm {
    id: number;
    name: string;
    phone1: string;
    phone2: string;
    email: string;
    customer: number;
    profession: number;

    constructor() {}
}